import React, { useState } from "react";
import { db } from "../../firebase";
import { collection, addDoc, doc, updateDoc, deleteDoc } from "firebase/firestore";

export default function ProjectsAdminSection({
  lang,
  projects,
  setProjects
}) {
  const [showModal, setShowModal] = useState(false);
  const [editingIdx, setEditingIdx] = useState(null);
  const [projectDraft, setProjectDraft] = useState({
    title: "",
    description: "",
    image: "",
    technologies: []
  });
  const [techDraft, setTechDraft] = useState({ name: "", icon: "" });

  // Abrir modal para agregar
  const openAddModal = () => {
    setEditingIdx(null);
    setProjectDraft({ title: "", description: "", image: "", technologies: [] });
    setShowModal(true);
  };

  // Abrir modal para editar
  const openEditModal = (idx) => {
    setEditingIdx(idx);
    setProjectDraft(projects[idx]);
    setShowModal(true);
  };

  // Guardar proyecto (nuevo o editado)
  const handleSave = async () => {
    let updated = [...projects];
    if (editingIdx === null) {
      const docRef = await addDoc(collection(db, "projects"), { ...projectDraft, lang });
      updated.push({ id: docRef.id, ...projectDraft });
    } else {
      await updateDoc(doc(db, "projects", projects[editingIdx].id), projectDraft);
      updated[editingIdx] = { ...projectDraft, id: projects[editingIdx].id };
    }
    setProjects(updated);
    setShowModal(false);
    setEditingIdx(null);
    setProjectDraft({ title: "", description: "", image: "", technologies: [] });
  };

  // Eliminar proyecto
  const handleDelete = async (idx) => {
    await deleteDoc(doc(db, "projects", projects[idx].id));
    setProjects(projects.filter((_, i) => i !== idx));
  };

  // Agregar tecnología al draft
  const handleAddTech = () => {
    if (!techDraft.name.trim()) return;
    setProjectDraft({
      ...projectDraft,
      technologies: [...(projectDraft.technologies || []), techDraft]
    });
    setTechDraft({ name: "", icon: "" });
  };

  // Eliminar tecnología del draft
  const handleDeleteTech = (i) => {
    setProjectDraft({
      ...projectDraft,
      technologies: projectDraft.technologies.filter((_, idx) => idx !== i)
    });
  };

  return (
    <section className="section">
      <h2 className="sectionTitle">Projects ({lang})</h2>
      <button className="button" style={{ marginBottom: 16 }} onClick={openAddModal}>
        Agregar proyecto
      </button>
      <ul className="list listColumn">
        {projects.map((proj, idx) => (
          <li key={idx} className="listItem" style={{ justifyContent: "space-between" }}>
            <div>
              <b>{proj.title}</b> - {proj.description}
              <br />
              <span style={{ fontSize: "0.95em", color: "#235390" }}>
                Technologies: {Array.isArray(proj.technologies)
                  ? proj.technologies.map(t => t.name).join(", ")
                  : ""}
              </span>
            </div>
            <div>
              <button className="iconBtn" title="Editar" onClick={() => openEditModal(idx)}>
                ✏️
              </button>
              <button
                onClick={() => handleDelete(idx)}
                className="buttonDanger"
              >
                X
              </button>
            </div>
          </li>
        ))}
      </ul>

      {/* === MODAL (Agregar/Editar Proyecto) === */}
      {showModal && (
        <div style={{
          position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
          background: "#0008", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000
        }}>
          <div style={{
            background: "#fff", borderRadius: 10, padding: 32, minWidth: 350, maxWidth: 500, width: "100%",
            boxShadow: "0 4px 32px #0002", display: "flex", flexDirection: "column", gap: 16
          }}>
            <h3 style={{ margin: 0 }}>{editingIdx !== null ? "Editar proyecto" : "Agregar proyecto"}</h3>
            <input
              className="input"
              placeholder="Título"
              value={projectDraft.title}
              onChange={e => setProjectDraft({ ...projectDraft, title: e.target.value })}
            />
            <textarea
              className="input"
              placeholder="Descripción"
              value={projectDraft.description}
              onChange={e => setProjectDraft({ ...projectDraft, description: e.target.value })}
              rows={3}
              style={{ resize: "vertical" }}
            />
            <input
              className="input"
              placeholder="URL de imagen"
              value={projectDraft.image}
              onChange={e => setProjectDraft({ ...projectDraft, image: e.target.value })}
            />
            {/* Technologies */}
            <div>
              <div style={{ marginBottom: 8, fontWeight: 500 }}>Technologies</div>
              <div style={{ display: "flex", gap: 8, marginBottom: 8 }}>
                <input
                  className="input"
                  placeholder="Nombre"
                  value={techDraft.name}
                  onChange={e => setTechDraft({ ...techDraft, name: e.target.value })}
                  style={{ flex: 1 }}
                />
                <input
                  className="input"
                  placeholder="Clase de icono (ej: devicon-react-original colored)"
                  value={techDraft.icon}
                  onChange={e => setTechDraft({ ...techDraft, icon: e.target.value })}
                  style={{ flex: 2 }}
                />
                <button className="buttonSmall" type="button" onClick={handleAddTech}>
                  +
                </button>
              </div>
              <ul style={{ margin: 0, padding: 0, listStyle: "none" }}>
                {(projectDraft.technologies || []).map((tech, i) => (
                  <li key={i} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
                    <span>{tech.name}</span>
                    <span>
                      <i className={tech.icon} style={{ fontSize: 18 }}></i>
                    </span>
                    <button
                      className="buttonDanger"
                      style={{ padding: "0 8px", fontSize: 14 }}
                      type="button"
                      onClick={() => handleDeleteTech(i)}
                    >X</button>
                  </li>
                ))}
              </ul>
            </div>
            <div style={{ display: "flex", gap: 12, justifyContent: "flex-end" }}>
              <button className="button" onClick={handleSave}>
                {editingIdx !== null ? "Guardar cambios" : "Agregar"}
              </button>
              <button className="buttonDanger" onClick={() => setShowModal(false)}>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}